import { Button } from '@missionlabs/smartagent-app-components';
import { format, isToday } from 'date-fns';
import { UserConversation } from 'graphql/types';
import React from 'react';
import { convertTime } from 'utils';
import Badge from '../../components/Badges/Badges';
import './index.scss';
import { useDispatch } from 'react-redux';
import InternalMessagingTypes from 'store/internal-messaging/internal-messaging.types';

interface Props {
    userConversations: UserConversation[] | undefined;
}


const ChatList: React.FC<Props> = ({ userConversations }) => {
    const sortConversations = (a:UserConversation,b:UserConversation)=>{
        return a.conversation.lastMessageTimestamp! > b.conversation.lastMessageTimestamp! ? -1 : 1;
    }

    const dispatch = useDispatch();

    return (
        <div className="chat-list">
            {userConversations?.filter(uc=>!!uc.conversation.lastMessageTimestamp).sort(sortConversations).map((uc) => {
                const { conversationId, name, conversation } = uc;
                const timestamp = conversation.lastMessageTimestamp!;
                return (
                    <div className="agent-chat-view" key={conversationId}>
                        <Button
                            className="agent-chat"
                            key={conversationId}
                            onClick={() =>
                                dispatch({
                                    type: InternalMessagingTypes.SELECT_CONVERSATION,
                                    payload: {
                                        id: conversationId
                                    }
                                })
                            }>
                            <div className="agent-chat-left-column">
                                    <span className="agent-chat-left-column-name">
                                        {name}
                                    </span>
                                    {conversation?.lastMessageContent ?
                                        <span className="agent-chat-left-column-message">
                                            {/* <img
                                                src={TickIcon}
                                                alt="Message Sent"
                                                title="Message Sent"
                                            />

                                            <img
                                                src={uc.unread ? UnreadTickIcon : TickIcon}
                                                alt={uc.unread ? "Unread messages" : "Message read"}
                                                title={uc.unread ? "Unread messages" : "Message read"}
                                                className="tick-icon"
                                            />    */}
                                            <span className="agent-chat-left-column-chat">
                                                {conversation?.lastMessageContent}
                                            </span>
                                        </span>
                                    : null }
                            </div>
                            <div className="agent-chat-right-column-notification">
                                {
                                isToday(timestamp) ? convertTime(timestamp) : format(timestamp,'dd/MM/yy')
                                }
                                {uc.unread > 0 ? <Badge number={uc.unread} /> : null }
                            </div>
                        </Button>
                        <div className="agent-chat-divider"></div>
                    </div>
                )
            })}
        </div>
    );
};




export default ChatList;
